export const FIELD_LABELS = {
  status: 'Статус',
  title: 'Состав заказа',
  offer_tag: 'Тег предложения',
  group: 'Группа',
  created_at: 'Дата создания',
}

export function emptyFilterGroup() {
  return { type: 'group', op: 'and', children: [] }
}

export function emptyCondition(field = 'status') {
  return {
    type: 'cond',
    field,
    negate: false,
    values: field === 'status' || field === 'offer_tag' || field === 'group' ? [] : undefined,
    pattern: field === 'title' ? '' : undefined,
    from: field === 'created_at' ? null : undefined,
    to: field === 'created_at' ? null : undefined,
  }
}

function formatDateParam(value) {
  if (!value) return null
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return typeof value === 'string' ? value : null
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export function simpleFiltersToExpr(simple) {
  const children = []
  if (simple.statuses?.length) {
    children.push({ type: 'cond', field: 'status', negate: false, values: [...simple.statuses] })
  }
  if (simple.title_pattern?.trim()) {
    children.push({ type: 'cond', field: 'title', negate: false, pattern: simple.title_pattern.trim() })
  }
  if (simple.offer_tags?.length) {
    children.push({ type: 'cond', field: 'offer_tag', negate: false, values: [...simple.offer_tags] })
  }
  if (simple.group_names?.length) {
    children.push({ type: 'cond', field: 'group', negate: false, values: [...simple.group_names] })
  }
  const from = formatDateParam(simple.created_from)
  const to = formatDateParam(simple.created_to)
  if (from || to) {
    children.push({ type: 'cond', field: 'created_at', negate: false, from, to })
  }
  return { type: 'group', op: 'and', children }
}

function isFlatAndGroup(node) {
  if (!node || node.type !== 'group' || node.op !== 'and') return false
  return (node.children || []).every((c) => c.type === 'cond')
}

export function exprToSimpleFilters(expr) {
  if (!isFlatAndGroup(expr)) return null
  const simple = {
    statuses: [],
    title_pattern: '',
    offer_tags: [],
    group_names: [],
    created_from: null,
    created_to: null,
  }
  for (const cond of expr.children) {
    if (cond.negate) return null
    if (cond.field === 'status' && cond.values?.length) {
      simple.statuses = [...cond.values]
    } else if (cond.field === 'title' && cond.pattern) {
      simple.title_pattern = cond.pattern
    } else if (cond.field === 'offer_tag' && cond.values?.length) {
      simple.offer_tags = [...cond.values]
    } else if (cond.field === 'group' && cond.values?.length) {
      simple.group_names = [...cond.values]
    } else if (cond.field === 'created_at') {
      simple.created_from = cond.from ? new Date(cond.from) : null
      simple.created_to = cond.to ? new Date(cond.to) : null
    } else {
      return null
    }
  }
  return simple
}

function previewCondition(cond) {
  const label = FIELD_LABELS[cond.field] || cond.field
  const not = cond.negate ? 'NOT ' : ''
  if (cond.field === 'title') {
    return `${not}${label} ∋ "${cond.pattern || ''}"`
  }
  if (cond.field === 'created_at') {
    const parts = []
    if (cond.from) parts.push(`от ${cond.from}`)
    if (cond.to) parts.push(`до ${cond.to}`)
    return `${not}${label} ${parts.join(' ')}`.trim()
  }
  const vals = (cond.values || []).join(', ')
  return `${not}${label} [${vals}]`
}

export function previewFilterExpr(node) {
  if (!node) return 'Без фильтра'
  if (node.type === 'cond') return previewCondition(node)
  if (node.type === 'group') {
    const parts = (node.children || [])
      .map((c) => previewFilterExpr(c))
      .filter((p) => p && p !== 'Без фильтра')
    if (!parts.length) return 'Без фильтра'
    const joiner = node.op === 'or' ? ' OR ' : ' AND '
    const inner = parts.length > 1 ? `(${parts.join(joiner)})` : parts[0]
    return inner
  }
  return 'Без фильтра'
}

export function cloneExpr(expr) {
  return JSON.parse(JSON.stringify(expr || emptyFilterGroup()))
}
